import type { TargetSource } from "@/features/stream-stats/api/stream-stats-queries"
// AC-3–AC-6: airtime Y-axis scale rules (overview chart only)
export const AIRTIME_AXIS_PADDING_RATIO = 0.1 // +10% of currentAirtimeHours headroom (AC-5/6)
export const AIRTIME_AXIS_DEFAULT_MAX_HOURS = 20 // no target/PB (AC-3)
export const AIRTIME_AXIS_EXCEED_THRESHOLD_HOURS = 15 // no target/PB, current > 15h → current+10% (AC-4)

const isPositiveValue = (value: number | undefined): value is number =>
  value !== undefined && Number.isFinite(value) && value > 0

/** AC-1: target/PB value from airtimeTargetMinutes; else none (AC-2). */
export function resolveAirtimeReferenceHours(data?: {
  airtimeTargetMinutes?: number
  airtimeTargetSource?: TargetSource
}): number | null {
  if (data?.airtimeTargetSource === "DEFAULT") return null

  if (isPositiveValue(data?.airtimeTargetMinutes)) {
    return Math.round((data.airtimeTargetMinutes ?? 0) / 60)
  }
  return null
}

export function computeAirtimeScaleMaxHours(
  currentAirtimeHours: number,
  referenceAirtimeHours: number | null
): number {
  const padding = currentAirtimeHours * AIRTIME_AXIS_PADDING_RATIO
  const paddedCurrent = currentAirtimeHours + padding

  if (referenceAirtimeHours === null) {
    // Case 4: no target or PB
    return Math.round(
      currentAirtimeHours > AIRTIME_AXIS_EXCEED_THRESHOLD_HOURS
        ? paddedCurrent
        : AIRTIME_AXIS_DEFAULT_MAX_HOURS
    )
  }

  // Cases 1–3: target or PB
  if (currentAirtimeHours > referenceAirtimeHours) {
    // Case 2: current above target/PB → 70 + 0.1×70 = 77
    return Math.round(paddedCurrent)
  }

  // Case 1 & 3: current at/below target/PB → 50 + 0.1×50 = 55, or 60 + 6 = 66
  const referencePadding = referenceAirtimeHours * AIRTIME_AXIS_PADDING_RATIO
  return Math.round(referenceAirtimeHours + referencePadding)
}
